import { useQuery } from '@tanstack/react-query'
import { trpc } from './trpc'

export const useCycleAdminAccess = () => {
	const { data, isLoading, error } = useQuery({
		...trpc.client.users.hasAnyCycleAdminAccess.queryOptions(),
		staleTime: 5 * 60 * 1000,
		retry: 1,
		retryOnMount: false,
	})

	return {
		hasAccess: data?.hasAccess ?? false,
		isLoading,
		error,
	}
}
